'use strict';

var angular = require('angular');

require('redi-common-angular');

var MODULE_NAME = 'rediRefDataWebLib';

var angularModule = angular.module(MODULE_NAME, [
  'redi-common',
  require('redi-idp-web-lib')
]);

require('./business/index.js')(angularModule);
require('./infrastructure/index.js')(angularModule);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-refdata-web-lib/dist/index.js
// module id = 108
// module chunks = 0